import React, { useState} from 'react'
import { Table,Container,Row,Card,CardHeader,CardBody,CardFooter, Button, Col } from "reactstrap";
import Header from 'components/Headers/Header';
import {report} from 'network/ApiAxiosTickets'
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import SellerDropdown from './SellerDropdown';
import Report from '@weknow/react-data-report';


const EventsSell = () => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [data, setData] = useState({});
    const [sellerID, setSellerID] = useState("");
    const [test, setTest] = useState();

    const role = JSON.parse(localStorage.getItem('user')).role

    const onChange = (dates) => {
        console.log(dates)
        //const [start, end] = dates;
        setStartDate(dates[0]);
        //setEndDate(dates[1]);
      };

    function addHours(numOfHours, date = new Date()) {
    date.setHours(date.getHours() + numOfHours);
    
    return date;
    }

    const getReport = async(e)=>{
        e.preventDefault()
        //console.log(sellerID)
        const emptyValue=0
        const convertStartDate = addHours(3,startDate)
        //const convertEndDate = addHours(2,endDate)
        
        const res = await report(convertStartDate,emptyValue,sellerID)
        if(res.data.success) {
            setData(res.data.totals)
            console.log(res.data)
            
            let ttt=Object.entries(res.data.totals.sellerName).map((row)=>{
                return {name:row[0],comission:row[1]}
            })
            console.log(ttt)
            setTest(ttt)
        }
        
    }

    const handleSellerFilter = (e)=>{
        console.log(e)
        setSellerID(e)
    }

    const tot =()=>{
        console.log('tot', data.Deposits)
        let tet =0
        parseInt(Object.entries(data.Deposits).map((row)=>{tet += row[1]}))
        return tet
    }

    return (
    <>
        
        {role == 'admin' && <Header/>}
        <Container fluid>
            <Row>
                <div className="col mt-6">
                    <Card className="shadow">
                        <CardHeader className="border-0">
                            <h2 className=' float-right'>Reports</h2>
                            <Row>
                                <Col>
                                    <label>Date:</label>
                                    <DatePicker
                                    //selected={startDate}
                                    selected={startDate}
                                    onChange={(d)=>setStartDate(d)}
                                    startDate={startDate}
                                    calendarStartDay={1}
                                    //endDate={endDate}
                                    dateFormat="dd/MM/yyyy"
                                    //selectsRange
                                    /> 
                                </Col>
                                <Col>
                                    <label>Seller:</label>
                                    <SellerDropdown width="200px" handler={(e)=>handleSellerFilter(e)} />
                                </Col>
                            </Row>   
                            <Button onClick={getReport}> GO </Button>
                        </CardHeader>
                        {data.sellerName &&
                        <CardBody>
                            
                            <h3>Totals</h3>
                            <Table className="align-items-center table-flush" hover responsive striped>
                                <tbody>
                                    <tr>
                                        <th scope="col">Total Money</th><th scope="col">{data.Money}</th>
                                    </tr>
                                    <tr>
                                        <th scope="col">Total Money Including Not Collected</th><th scope="col">{tot() + data.Money }</th>
                                    </tr>
                                    <tr>
                                        <th scope="col">Total Seller Comission</th><th scope="col">{data.SellerComission}</th>
                                    </tr>
                                </tbody>
                            </Table>

                            {data.sellerName &&
                            <>
                            <h3>Seller Comissions</h3>
                            <Table className="align-items-center table-flush" hover responsive striped>
                                <thead className="thead-light">
                                    <tr>
                                        <th scope="col">Seller</th>
                                        <th scope="col">Comission</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    
                                    {Object.entries(data.sellerName).map((row)=>{
                                        return <tr key={row[0]}><th scope="col">{row[0]}</th><th scope="col">{row[1]}</th></tr>
                                    })}
                                    
                                </tbody>
                            </Table>
                            </>}
                            

                            {data.missing &&
                            <>
                            <h3>Money not given to shop</h3>
                            <Table className="align-items-center table-flush" hover responsive striped>
                                <thead className="thead-light">
                                    <tr>
                                        <th scope="col">Seller</th>
                                        <th scope="col">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.entries(data.missing).map((row)=>{
                                        return <tr><th scope="col">{row[0]}</th><th scope="col">{row[1]}</th></tr>
                                    })}
                                    
                                </tbody>
                            </Table>
                            </>}

                            <h3>Deposits not Collected</h3>
                            <Table className="align-items-center table-flush" hover responsive striped>
                                <thead className="thead-light">
                                    <tr>
                                        <th scope="col">Event</th>
                                        <th scope="col">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.entries(data.Deposits).map((row)=>{
                                        return <tr key={row[0] + row[1]}><th scope="col">{row[0]}</th><th scope="col">{row[1]}</th></tr>
                                    })}
                                    
                                </tbody>
                            </Table>

                            <h3>Sales By Event</h3>
                            <Table className="align-items-center table-flush" hover responsive striped>
                                <thead className="thead-light">
                                    <tr>
                                        <th scope="col">Event</th>
                                        <th scope="col">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.entries(data.eventNumbers).map((row)=>{
                                        return <tr key={row[0] + row[1]}><th scope="col">{row[0]}</th><th scope="col">{row[1]}</th></tr>
                                    })}
                                    
                                </tbody>
                            </Table>


                            {test&&<Report data={ test} pageSize='a4' pageFormat={2} itemsPerPage={30} opening={(<h1>Comission Report {startDate.toISOString().split('T')[0]}.</h1>)}/>}

                        </CardBody>
                        }
                        <CardFooter className="py-4">
                        </CardFooter>
                    </Card>
                </div>
            </Row>
        </Container>
    </>
    )
}

export default EventsSell
